import { ChannelInfo } from '@/models/forumAPI/ChannelModel';

export interface PaginationInfo {
  hasNextPage?: boolean;
  hasPreviousPage?: boolean;
  numberOfItems?: number;
  pageSize?: number;
  totalNumberOfPages?: number;
}
export interface ChannelState {
  channels: { [key: string]: ChannelInfo };
  pagination: PaginationInfo;
}

const state: ChannelState = {
  channels: {},
  pagination: {},
};

export default state;
